// Filename: gani_ui.js
// Timestamp: 2018.12.10-09:23:10 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>
//
// basic methods for all ui nodes. use as base and redefine functions as needed

import {
  gnaccSubj as accSubj
} from './gnacc.js'

import {
  gnenumKEY as KEY
} from './gnenum.js'

import {
  gnrun
} from './gnrun.js'

import {
  gnerrLog as errLog,
  gnerr_nodeevhandlermustbelist
} from './gnerr.js'

import {
  gnpublish_subj
} from './gnpublish.js'

import {
  gnspec_clientis as specClientIs
} from './gnspec.js'

const keyOrNodeAsKey = keyOrNode => (
  typeof keyOrNode === 'string' ? keyOrNode : keyOrNode.get(KEY))

const xinit = node => node

const xreset = node => node

const xonchildremove = (sess, cfg, graph, node, cnode) => (
  [graph, node, cnode])

// partial inheritor should define own method here
const xhydratedsubj = (ss, cfg, gr, nd/*, ndx*/) => [gr, nd]

const xhydratedbase = (ss, cfg, gr, nd/*, ndx*/) => [gr, nd]

const prevset = (cfg, nd, subj) => (
  cfg.prev[nd.get(KEY)] = Object.assign({}, subj))

const prevget = (cfg, nd) => (
  cfg.prev[nd.get(KEY)] ||
    prevset(cfg, nd, accSubj.get(nd, {})))

const evActionSpecsApply = async (ss, cfg, gr, nd, ns, actionspecs) => {
  if (actionspecs.length <= 0)
    return (cfg.graph = gr) // persist graph

  const actionspec = actionspecs[0]

  if (!specClientIs(actionspec))
    return gr

  try { // can mutate graph
    gr = await gnrun(ss, cfg, gr, nd, ns, actionspec, true)
  } catch (e) {
    errLog(cfg, gr, nd, { message: e.message, stack: e.stack })
  }

  return evActionSpecsApply(ss, cfg, gr, nd, ns, actionspecs.slice(1))
}

// call evPublishPOST() after action changes published from node
// an evPublishPRE() wold be called before changes published
//
// when a node publishes changes which remove that same node from graph,
// actionspecs will not be applied for that node
//
// for example, if checking a todo-list-item removes that item
// from todolist, changes specified at POST are not applied
// returns a new graph updated through events at evname
const publishevPOSTns = async (ss, cfg, gr, nd, xevname, ns = {}) => {
  nd = gr.get(keyOrNodeAsKey(nd))

  // node does not exist in graph
  if (!nd)
    return gr

  const evname = xevname.startsWith('x')
    ? xevname.slice(1) : xevname
  const onaction = nd.get(evname)
  if (!onaction)
    return gr

  if (!Array.isArray(onaction))
    throw gnerr_nodeevhandlermustbelist(gr, nd, evname, onaction)

  return evActionSpecsApply(ss, cfg, gr, nd, ns, onaction)
}

//  async (ss, cfg, nd, subj, istarget = !(nd && nd.get(ISDATA))) => {
const publish = async (ss, cfg, keyOrNd, subj) => {
  const ndkey = keyOrNodeAsKey(keyOrNd)

  return gnpublish_subj(ss, cfg, ndkey, subj)
}

// publish the event _and_ call PRE and POST event specs
const publishev = async (ss, cfg, nd, ev, subj) => {
  const ndkey = keyOrNodeAsKey(nd)
  let gr = cfg.graph

  if (subj) {
    gr = (await gnpublish_subj(ss, cfg, ndkey, subj))[0]
  }

  // returns 'gr'
  return publishevPOSTns(ss, cfg, gr, nd, ev, {})
}

export default {
  type: 'gnnodex',
  xinit,
  xreset,
  xonchildremove,
  xhydratedsubj,
  xhydratedbase,
  prevset,
  prevget,
  evActionSpecsApply,
  publish,
  publishev,
  publishevPOSTns
}
